export function normalizePathnameForMatch(pathname: string): string {
  if (!pathname) return '/';
  const withoutQuery = pathname.split('?')[0] ?? pathname;
  const trimmed = withoutQuery.replace(/\/+$/, '');
  return trimmed === '' ? '/' : trimmed;
}

export function isPayequitySettingsRoute(pathname: string): boolean {
  const p = normalizePathnameForMatch(pathname);
  if (p.includes('/payequity/settings')) {
    return true;
  }
  const segments = p.split('/').filter(Boolean);
  if (segments.length === 1 && segments[0] === 'settings') {
    return true;
  }
  return false;
}

const toastBaseStyle: Record<string, string> = {
  right: '10px',
  top: '88px',
  maxWidth: 'min(28rem, calc(100vw - 6rem))',
};

const settingsToastStyle: Record<string, string> = {
  left: '15%',
  bottom: '45px',
  maxWidth: 'min(28rem, calc(100vw - 6rem))',
};

export function getPayequityToastPositionStyle(pathname: string): Record<string, string> {
  if (isPayequitySettingsRoute(pathname)) {
    return { ...settingsToastStyle };
  }
  return { ...toastBaseStyle };
}
